export default __webpack_public_path__ + "static/media/system-settings.f2738712.svg";